import { Link } from 'react-router-dom';
import { useSettings } from '@/contexts/SettingsContext';
import { MapPin, Phone, Mail, Clock } from 'lucide-react';

export function Footer() {
    const { settings } = useSettings();

    return (
        <footer className="bg-[var(--brand-navy)] text-white/90" data-testid="main-footer">
            <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 py-12">
                <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
                    {/* Brand */}
                    <div>
                        <div className="flex items-center gap-2 mb-4">
                            <img src="/images/asg-logo.png" alt="ASG Motor" className="h-10 w-auto brightness-0 invert opacity-90" />
                        </div>
                        <p className="text-sm text-white/60 leading-relaxed max-w-xs">
                            {settings?.company_description || 'Tu concesionario de confianza en Don Benito.'}
                        </p>
                    </div>

                    {/* Quick Links */}
                    <div>
                        <h3 className="font-[var(--font-display)] font-semibold mb-4">Navegación</h3>
                        <nav className="flex flex-col gap-2">
                            <Link to="/" className="text-sm text-white/60 hover:text-white transition-colors duration-200">Inicio</Link>
                            <Link to="/coches" className="text-sm text-white/60 hover:text-white transition-colors duration-200">Vehículos</Link>
                            <Link to="/nosotros" className="text-sm text-white/60 hover:text-white transition-colors duration-200">Nosotros</Link>
                            <Link to="/contacto" className="text-sm text-white/60 hover:text-white transition-colors duration-200">Contacto</Link>
                        </nav>
                    </div>

                    {/* Contact */}
                    <div>
                        <h3 className="font-[var(--font-display)] font-semibold mb-4">Contacto</h3>
                        <div className="flex flex-col gap-3">
                            <div className="flex items-start gap-2">
                                <MapPin className="h-4 w-4 mt-0.5 text-white/40 shrink-0" />
                                <span className="text-sm text-white/60">{settings?.address || 'Don Benito, Badajoz'}</span>
                            </div>
                            <div className="flex items-center gap-2">
                                <Phone className="h-4 w-4 text-white/40 shrink-0" />
                                <a href={`tel:${settings?.phone}`} className="text-sm text-white/60 hover:text-white transition-colors duration-200">
                                    {settings?.phone || '+34 600 000 000'}
                                </a>
                            </div>
                            <div className="flex items-center gap-2">
                                <Mail className="h-4 w-4 text-white/40 shrink-0" />
                                <a href={`mailto:${settings?.email}`} className="text-sm text-white/60 hover:text-white transition-colors duration-200">
                                    {settings?.email || 'info@asgmotor.com'}
                                </a>
                            </div>
                            <div className="flex items-start gap-2">
                                <Clock className="h-4 w-4 mt-0.5 text-white/40 shrink-0" />
                                <span className="text-sm text-white/60">{settings?.schedule || 'L-V: 9-14 / 16:30-20 | S: 10-14'}</span>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="mt-10 pt-6 border-t border-white/10 flex flex-col sm:flex-row items-center justify-between gap-3">
                    <p className="text-xs text-white/40">
                        &copy; {new Date().getFullYear()} ASG Motor. Todos los derechos reservados.
                    </p>
                    <nav className="flex gap-4">
                        <Link to="/aviso-legal" className="text-xs text-white/40 hover:text-white/70 transition-colors duration-200">Aviso Legal</Link>
                        <Link to="/politica-privacidad" className="text-xs text-white/40 hover:text-white/70 transition-colors duration-200">Privacidad</Link>
                        <Link to="/politica-cookies" className="text-xs text-white/40 hover:text-white/70 transition-colors duration-200">Cookies</Link>
                    </nav>
                </div>
            </div>
        </footer>
    );
}
